/**
 * filter ticket lists
 * @constructor
 */
$.fn.FilteringTicket = function(){
	$(this).find('.filter-ticket').on('click.filter',function () {

		var $ticketContent = $(this).parents('.js-filterticket').parent().find('.js-filtercontent');

		var $filterValue = $(this).attr('data-filter');
		var $filterItem = $(this).parents('.js-filterticket').parent().find('.js-filtercontent .ticket-list li');

		$filterItem.each( function () {
			$(this).removeClass('hide');
		});

		$('.filter-ticket').removeClass('active');
		$(this).addClass('active');

		if( windowWidth <= SCREEN.SM ) {
			$("html, body").animate({scrollTop: $ticketContent.offset().top - $pageWrap.offset().top - 20}, 1000, "easeInOutExpo");
		}

		if( $filterValue === 'all' ){
			$filterItem.each( function () {
				$(this).removeClass('hide');
			});
		}else{
			$filterItem.each( function () {
				$(this).removeClass('hide');
				if( !$(this).hasClass( $filterValue ) ) {
					$(this).addClass('hide');
				}
			});
		}

	});
};

$(function() {
	if ($('.tab').hasClass('tab--tickets')) {
		$('.tab--tickets').each(function() {
			$(this).find('.js-filterticket').FilteringTicket();
		});
	} else {
		$('.js-filterticket').parent().FilteringTicket()
	}
});